var _path, _g, _path2, _path3, _path4, _path5, _circle, _line, _line2, _path6, _path7, _circle2, _line3, _path8, _path9, _circle3, _line4, _path10, _path11, _circle4, _line5, _path12, _path13, _path14, _path15, _path16, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusiness3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 749,
    height: 666,
    viewBox: "0 0 749 666",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4559_930",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 233,
    y: 549,
    width: 300,
    height: 59
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M532.621 549.329H233.021V607.604H532.621V549.329Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4559_930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.688 602.934C453.857 602.934 511.55 545.222 511.55 474.03C511.55 402.838 453.857 345.125 382.688 345.125C311.52 345.125 253.827 402.838 253.827 474.03C253.827 545.222 311.52 602.934 382.688 602.934Z",
    fill: "#FFC289"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M233.021 547.248H532.622",
    stroke: "#343239",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M462.411 57L303.72 57C288.483 57 276.127 69.3521 276.122 84.5891L276.009 423.015C276.004 438.252 288.352 450.605 303.589 450.605H462.28C477.517 450.605 489.873 438.252 489.878 423.015L489.934 253.802L489.991 84.5891C489.996 69.3521 477.648 57 462.411 57Z",
    fill: "#F6F3F3",
    stroke: "#343239",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M373.348 156.376H390.903C399.038 156.376 405.661 149.794 405.661 141.64V113.002C398.556 116.47 394.408 121.542 390.485 133.164C386.112 146.07 380.582 152.299 373.348 156.408V156.376Z",
    fill: "#1A1A1A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M401.128 109.567H373.54C365.406 109.567 358.782 116.148 358.782 124.303V145.267C369.039 143.309 373.862 138.108 379.682 129.086C387.463 116.951 390.839 113.548 401.128 109.567V109.567Z",
    fill: "#1A1A1A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 308.814,
    cy: 235.043,
    r: 18.3769,
    fill: "#FBF9F9",
    stroke: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 345.847,
    y1: 232.432,
    x2: 470.544,
    y2: 232.432,
    stroke: "#343239",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 351.124,
    y1: 72.7012,
    x2: 416.301,
    y2: 71.6985,
    stroke: "#343239",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M344.347 243.426C344.071 243.426 343.847 243.65 343.847 243.926C343.847 244.202 344.071 244.426 344.347 244.426V243.426ZM344.347 244.426H433.179V243.426H344.347V244.426Z",
    fill: "#343239"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M344.347 253.975C344.071 253.975 343.847 254.198 343.847 254.475C343.847 254.751 344.071 254.975 344.347 254.975V253.975ZM344.347 254.975H433.179V253.975H344.347V254.975Z",
    fill: "#343239"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.814,
    cy: 288.342,
    r: 18.3769,
    fill: "#FBF9F9",
    stroke: "black"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 345.847,
    y1: 285.732,
    x2: 470.544,
    y2: 285.732,
    stroke: "#343239",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M344.347 296.725C344.071 296.725 343.847 296.949 343.847 297.225C343.847 297.501 344.071 297.725 344.347 297.725V296.725ZM344.347 297.725H433.179V296.725H344.347V297.725Z",
    fill: "#343239"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M344.347 307.274C344.071 307.274 343.847 307.498 343.847 307.774C343.847 308.05 344.071 308.274 344.347 308.274V307.274ZM344.347 308.274H433.179V307.274H344.347V308.274Z",
    fill: "#343239"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.814,
    cy: 347.194,
    r: 18.3769,
    fill: "#FBF9F9",
    stroke: "black"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 345.847,
    y1: 344.583,
    x2: 470.544,
    y2: 344.583,
    stroke: "#343239",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M344.347 355.577C344.071 355.577 343.847 355.801 343.847 356.077C343.847 356.353 344.071 356.577 344.347 356.577V355.577ZM344.347 356.577H433.179V355.577H344.347V356.577Z",
    fill: "#343239"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M344.347 366.126C344.071 366.126 343.847 366.35 343.847 366.626C343.847 366.902 344.071 367.126 344.347 367.126V366.126ZM344.347 367.126H433.179V366.126H344.347V367.126Z",
    fill: "#343239"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 311.035,
    cy: 406.045,
    r: 18.3769,
    fill: "#FBF9F9",
    stroke: "black"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 348.068,
    y1: 403.435,
    x2: 472.764,
    y2: 403.435,
    stroke: "#343239",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M346.568 414.428C346.291 414.428 346.068 414.652 346.068 414.928C346.068 415.205 346.291 415.428 346.568 415.428V414.428ZM346.568 415.428H435.4V414.428H346.568V415.428Z",
    fill: "#343239"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M346.568 424.977C346.291 424.977 346.068 425.201 346.068 425.477C346.068 425.753 346.291 425.977 346.568 425.977V424.977ZM346.568 425.977H435.4V424.977H346.568V425.977Z",
    fill: "#343239"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M298.792 243.583C298.528 244.244 297.489 243.857 297.752 243.194C298.872 240.39 301.41 233.007 304.833 232.466C307.787 231.998 311.139 236.125 313.231 235.733C315.481 235.313 317.279 228.411 317.841 226.462C316.876 226.813 316.688 225.728 317.308 225.504C319.07 224.864 318.726 224.736 319.809 226.208C320.224 226.772 319.354 227.427 318.894 226.824C318.163 229.356 316.439 236.233 313.441 236.795C310.714 237.306 307.428 233.149 305.012 233.532C302.3 233.961 299.694 241.324 298.792 243.583Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M305.054 279.227V288.985H300.756C300.412 288.985 300.068 289.161 299.982 289.513C299.896 289.864 299.896 290.216 300.154 290.48L308.836 299.182C309.18 299.534 309.696 299.534 310.04 299.182L318.55 290.392C318.722 290.216 318.808 290.04 318.808 289.776C318.808 289.688 318.808 289.513 318.722 289.425C318.55 289.073 318.292 288.897 317.948 288.897L313.65 288.985V279.227C313.65 278.7 313.306 278.348 312.79 278.348H305.913C305.398 278.348 305.054 278.7 305.054 279.227ZM311.931 280.106V289.864C311.931 290.128 312.017 290.304 312.189 290.48C312.36 290.655 312.532 290.743 312.79 290.743L315.885 290.655L309.438 297.336L302.905 290.743H305.913C306.429 290.743 306.773 290.392 306.773 289.864V280.106H311.931Z",
    fill: "#343239"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M313.684 356.308V346.551H317.983C318.326 346.551 318.67 346.375 318.756 346.023C318.842 345.671 318.842 345.32 318.584 345.056L309.902 336.353C309.558 336.002 309.043 336.002 308.699 336.353L300.189 345.144C300.017 345.32 299.931 345.496 299.931 345.759C299.931 345.847 299.931 346.023 300.017 346.111C300.189 346.463 300.446 346.638 300.79 346.638L305.088 346.551V356.308C305.088 356.836 305.432 357.187 305.948 357.187H312.825C313.341 357.187 313.684 356.836 313.684 356.308ZM306.808 355.429V345.671C306.808 345.408 306.722 345.232 306.55 345.056C306.378 344.88 306.206 344.792 305.948 344.792L302.853 344.88L309.3 338.199L315.834 344.792H312.825C312.309 344.792 311.965 345.144 311.965 345.671V355.429H306.808Z",
    fill: "#343239"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4559_930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.154 393.9H302.915C302.795 393.9 302.68 393.948 302.596 394.034C302.511 394.12 302.464 394.237 302.464 394.358V418.176C302.464 418.298 302.511 418.414 302.596 418.5C302.68 418.586 302.795 418.634 302.915 418.634H319.154C319.274 418.634 319.389 418.586 319.473 418.5C319.558 418.414 319.606 418.298 319.606 418.176V394.358C319.606 394.237 319.558 394.12 319.473 394.034C319.389 393.948 319.274 393.9 319.154 393.9ZM318.703 417.718H303.366V394.816H318.703V417.718Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.17 402.145C305.276 402.145 305.378 402.108 305.459 402.039L307.877 399.987L309.848 401.586C309.925 401.642 310.017 401.673 310.112 401.673C310.207 401.673 310.299 401.642 310.376 401.586L314.192 399.048L316.191 400.67C316.236 400.713 316.29 400.747 316.349 400.768C316.408 400.79 316.47 400.798 316.533 400.794C316.595 400.789 316.656 400.772 316.711 400.742C316.766 400.712 316.815 400.671 316.854 400.622C316.892 400.572 316.921 400.515 316.937 400.454C316.953 400.392 316.956 400.328 316.946 400.266C316.936 400.203 316.914 400.143 316.88 400.09C316.846 400.036 316.802 399.99 316.75 399.955L314.495 398.123C314.42 398.064 314.329 398.029 314.234 398.025C314.14 398.021 314.046 398.047 313.967 398.1L310.178 400.661L308.179 399.039C308.099 398.973 307.998 398.937 307.895 398.937C307.791 398.937 307.691 398.973 307.611 399.039L304.904 401.329C304.858 401.368 304.821 401.415 304.793 401.468C304.765 401.522 304.748 401.58 304.743 401.64C304.737 401.7 304.744 401.761 304.761 401.818C304.779 401.876 304.808 401.929 304.846 401.975C304.885 402.025 304.934 402.066 304.99 402.095C305.046 402.124 305.108 402.141 305.17 402.145Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.546 405.809H306.524C306.404 405.809 306.289 405.858 306.205 405.943C306.12 406.029 306.073 406.146 306.073 406.267C306.073 406.389 306.12 406.505 306.205 406.591C306.289 406.677 306.404 406.725 306.524 406.725H315.546C315.665 406.725 315.78 406.677 315.865 406.591C315.949 406.505 315.997 406.389 315.997 406.267C315.997 406.146 315.949 406.029 315.865 405.943C315.78 405.858 315.665 405.809 315.546 405.809Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.546 409.932H306.524C306.404 409.932 306.289 409.98 306.205 410.066C306.12 410.152 306.073 410.268 306.073 410.39C306.073 410.511 306.12 410.628 306.205 410.714C306.289 410.799 306.404 410.848 306.524 410.848H315.546C315.665 410.848 315.78 410.799 315.865 410.714C315.949 410.628 315.997 410.511 315.997 410.39C315.997 410.268 315.949 410.152 315.865 410.066C315.78 409.98 315.665 409.932 315.546 409.932Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.546 414.054H306.524C306.404 414.054 306.289 414.102 306.205 414.188C306.12 414.274 306.073 414.391 306.073 414.512C306.073 414.633 306.12 414.75 306.205 414.836C306.289 414.922 306.404 414.97 306.524 414.97H315.546C315.665 414.97 315.78 414.922 315.865 414.836C315.949 414.75 315.997 414.633 315.997 414.512C315.997 414.391 315.949 414.274 315.865 414.188C315.78 414.102 315.665 414.054 315.546 414.054Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4559_930"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.8706,
    height: 36.6434,
    fill: "white",
    transform: "translate(296.599 391.61)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness3);
export default __webpack_public_path__ + "static/media/business-3.c248cffc017df817c7881012fb3206fd.svg";
export { ForwardRef as ReactComponent };